import { useEffect, useState } from 'react'
import { sgBaseUrl } from '@fs/zion-config'
import { useUser } from '@fs/zion-user'
import axios from '../utils/giveAxios'

const url = `${sgBaseUrl}/service/ident/cas/cas-public-api/authorizations`

const permissions = {
  administerEvents: 'GetInvolvedAdministerEvents',
  manageFlaggedBehaviors: 'GetInvolvedManageFlaggedBehaviors',
  manageTempPositions: 'GetInvolvedManageTempPositions',
  manageUnitStats: 'GetInvolvedManageUnitStats',
  postToSqsClient: 'GetInvolvedPostToSqsClient',
  proxyUser: 'GetInvolvedProxyUser',
  viewFlaggedBehaviors: 'GetInvolvedViewFlaggedBehaviors',
  viewProxiedUsers: 'GetInvolvedViewProxiedUsers',
  viewTempPositions: 'GetInvolvedViewTempPositions',
}

const allPermissions = Object.values(permissions)

const allFalse = Object.fromEntries(Object.keys(permissions).map((key) => [key, false]))

function getFeatures(data) {
  const authorizationResults = data?.results || []
  if (authorizationResults.length === 0) return allFalse

  const unauthorizedPermissions = new Set(
    authorizationResults.flatMap((x) => x.unauthorizedPermissions || [])
  )
  const authorized = (permission) => !unauthorizedPermissions.has(permission)

  return {
    administerEvents: authorized(permissions.administerEvents),
    manageFlaggedBehaviors: authorized(permissions.manageFlaggedBehaviors),
    manageTempPositions: authorized(permissions.manageTempPositions),
    manageUnitStats: authorized(permissions.manageUnitStats),
    postToSqsClient: authorized(permissions.postToSqsClient),
    proxyUser: authorized(permissions.proxyUser),
    viewFlaggedBehaviors: authorized(permissions.viewFlaggedBehaviors),
    viewProxiedUsers: authorized(permissions.viewProxiedUsers),
    viewTempPositions: authorized(permissions.viewTempPositions),
  }
}

export default function useAdminAccess() {
  const [data, setData] = useState()
  const [error, setError] = useState()
  const [loading, setLoading] = useState(true)
  const { signedIn, userLoading } = useUser()

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data: authData } = await axios.post(url, {
          authorizationRequests: [
            {
              context: 'GetInvolvedContext',
              permissions: allPermissions,
            },
          ],
        })
        setData(getFeatures(authData))
      } catch (err) {
        setError(err)
      } finally {
        setLoading(false)
      }
    }
    if (signedIn && !userLoading) {
      setLoading(true)
      setError(undefined)
      fetchData()
    } else if (!signedIn && !userLoading) {
      setData(undefined)
      setError(undefined)
      setLoading(false)
    }
  }, [signedIn, userLoading])

  const hasAnyPermission = data ? Object.values(data).some(Boolean) : false

  return { data, error, loading, hasAccess: hasAnyPermission }
}
